import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { createContext } from "react";
import Home from "./Home";










const MyContext = createContext();

function App() {

  
  return (

    <BrowserRouter>
      {/* <MyContext.Provider value={values}>
            <Toaster position="bottom-left" richColors />


        {
          headeractive && <Header />
        } */}

        <Routes>
          <Route path="/" exact={true} element={<Home />} /> 
        

        </Routes>


      {/* </MyContext.Provider> */}
    </BrowserRouter>


  );
}

export default App;

export { MyContext }
